module.exports = __webpack_public_path__ + "static/media/e3.537cf110.jpg";